/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EmailStorageStatsFoldersInner } from './EmailStorageStatsFoldersInner';
import {
    EmailStorageStatsFoldersInnerFromJSON,
    EmailStorageStatsFoldersInnerFromJSONTyped,
    EmailStorageStatsFoldersInnerToJSON,
} from './EmailStorageStatsFoldersInner';
import type { EmailStorageStatsInbox } from './EmailStorageStatsInbox';
import {
    EmailStorageStatsInboxFromJSON,
    EmailStorageStatsInboxFromJSONTyped,
    EmailStorageStatsInboxToJSON,
} from './EmailStorageStatsInbox';
import type { EmailStorageStatsSentItems } from './EmailStorageStatsSentItems';
import {
    EmailStorageStatsSentItemsFromJSON,
    EmailStorageStatsSentItemsFromJSONTyped,
    EmailStorageStatsSentItemsToJSON,
} from './EmailStorageStatsSentItems';

/**
 * 
 * @export
 * @interface EmailStorageStats
 */
export interface EmailStorageStats {
    /**
     * 
     * @type {number}
     * @memberof EmailStorageStats
     */
    totalSizeBytes?: number;
    /**
     * 
     * @type {string}
     * @memberof EmailStorageStats
     */
    totalSizeMB?: string;
    /**
     * 
     * @type {Array<EmailStorageStatsFoldersInner>}
     * @memberof EmailStorageStats
     */
    folders?: Array<EmailStorageStatsFoldersInner>;
    /**
     * 
     * @type {EmailStorageStatsSentItems}
     * @memberof EmailStorageStats
     */
    sentItems?: EmailStorageStatsSentItems | null;
    /**
     * 
     * @type {EmailStorageStatsInbox}
     * @memberof EmailStorageStats
     */
    inbox?: EmailStorageStatsInbox | null;
    /**
     * 
     * @type {EmailStorageStatsSentItems}
     * @memberof EmailStorageStats
     */
    deletedItems?: EmailStorageStatsSentItems | null;
}

/**
 * Check if a given object implements the EmailStorageStats interface.
 */
export function instanceOfEmailStorageStats(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EmailStorageStatsFromJSON(json: any): EmailStorageStats {
    return EmailStorageStatsFromJSONTyped(json, false);
}

export function EmailStorageStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailStorageStats {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalSizeBytes': !exists(json, 'totalSizeBytes') ? undefined : json['totalSizeBytes'],
        'totalSizeMB': !exists(json, 'totalSizeMB') ? undefined : json['totalSizeMB'],
        'folders': !exists(json, 'folders') ? undefined : ((json['folders'] as Array<any>).map(EmailStorageStatsFoldersInnerFromJSON)),
        'sentItems': !exists(json, 'sentItems') ? undefined : EmailStorageStatsSentItemsFromJSON(json['sentItems']),
        'inbox': !exists(json, 'inbox') ? undefined : EmailStorageStatsInboxFromJSON(json['inbox']),
        'deletedItems': !exists(json, 'deletedItems') ? undefined : EmailStorageStatsSentItemsFromJSON(json['deletedItems']),
    };
}

export function EmailStorageStatsToJSON(value?: EmailStorageStats | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalSizeBytes': value.totalSizeBytes,
        'totalSizeMB': value.totalSizeMB,
        'folders': value.folders === undefined ? undefined : ((value.folders as Array<any>).map(EmailStorageStatsFoldersInnerToJSON)),
        'sentItems': EmailStorageStatsSentItemsToJSON(value.sentItems),
        'inbox': EmailStorageStatsInboxToJSON(value.inbox),
        'deletedItems': EmailStorageStatsSentItemsToJSON(value.deletedItems),
    };
}

